import { SVGProps } from "react";

export function CalendarIcon({
    stroke = "#667085",
    xmlns = "http://www.w3.org/2000/svg",
    ...props
}: SVGProps<SVGSVGElement>) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.8333 5H4.16667C3.24619 5 2.5 5.74619 2.5 6.66667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V6.66667C17.5 5.74619 16.7538 5 15.8333 5Z" stroke="#667085" stroke-width="1.66667" />
            <path d="M2.5 8.33333C2.5 6.76167 2.5 5.97667 2.98833 5.48833C3.47667 5 4.26167 5 5.83333 5H14.1667C15.7383 5 16.5233 5 17.0117 5.48833C17.5 5.97667 17.5 6.76167 17.5 8.33333H2.5Z" fill="#667085" />
            <path d="M5.83325 2.5V5M14.1666 2.5V5" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" />
        </svg>
    );
}